
//gtag track visitors that interact with the first phase of the nitrogen profit calculator, effectively selecting a nitrogen source
export function gtag_report_conversion_nitrogen_source(url) {
	var callback = function () {
		if (typeof(url) != 'undefined') {
			window.location = url;
		}
	};
	gtag('event', 'conversion', {
 	 	'send_to': 'AW-979130049/FkLUCOCiv9sBEMGt8dID',
  		'event_callback': callback
	});
	return false;
}

//track visitors that click the “calculate my profit” CTA on the Nitrogen Profit Calculator
export function gtag_report_conversion_calculate_profit(url) {
	var callback = function () {
		if (typeof(url) != 'undefined') {
			window.location = url;
		}
	};
	gtag('event', 'conversion', {
 	 	'send_to': 'AW-979130049/-CYwCO6_29sBEMGt8dID',
  		'event_callback': callback
	});
	return false;
}

// export function gtag() {
// 	console.log('gtag function');
// };